import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
// Components
import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { PolicyModalComponent } from './footer/policy-modal/policy-modal.component';
import { SearchbarComponent } from './navbar/searchbar/searchbar.component';
import { UserDropdownComponent } from './navbar/user-dropdown/user-dropdown.component';
import { ShoppingCartComponent } from './navbar/shopping-cart/shopping-cart.component';
import { CartDiscountComponent } from './navbar/shopping-cart/cart-discount/cart-discount.component';
import { CartSubtotalComponent } from './navbar/shopping-cart/cart-subtotal/cart-subtotal.component';
import { CartButtonComponent } from './navbar/cart-button/cart-button.component';
import { ToastsContainerComponent } from './services/toasts-container/toasts-container.component';
// Services
import { BroadcasterService } from './services/broadcaster.service';
import { SearchbarService } from './navbar/searchbar/searchbar.service';
import { ShoppingCartService } from './navbar/shopping-cart/shopping-cart.service';
import { ApiService } from './services/api.service';
import { TokenService } from './services/token.service';
import { AuthService } from './services/auth.service';
import { MetaTagService } from './services/meta-tag.service';
import { FooterService } from './footer/footer.service';
import { ScrollSpyService } from './services/scroll-watch/scroll-watch.service';
// Directives
import { ScrollSpyElementDirective } from './services/scroll-watch/scroll-watch.directive';
// Custom Pipe
import { KeysPipe } from './services/pipes/keys.pipe';

const appRoutes: Routes = [{
  path: '',
  redirectTo: 'user-management',
  pathMatch: 'full'
}, {
  path: 'login',
  loadChildren: 'app/login/login.module#LoginModule'
}, {
//   path: 'home',
//   loadChildren: 'app/home/home.module#HomeModule'
// }, {
//   path: 'lazy',
//   loadChildren: 'app/lazy/lazy.module#LazyModule'
// }, {
  path: 'user-management',
  loadChildren: 'app/user-management/user-management.module#UserManagementModule'
}, {
  path: 'find-my-order',
  loadChildren: 'app/find-my-order/find-my-order.module#FindMyOrderModule'
}, {
  path: 'seller-access',
  loadChildren: 'app/seller-access/seller-access.module#SellerAccessModule'
}, {
  path: '**',
  redirectTo: 'user-management'
}];

@NgModule({
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    HttpClientModule,
    FormsModule
  ],
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    PolicyModalComponent,
    SearchbarComponent,
    UserDropdownComponent,
    ShoppingCartComponent, // NOT IN USE
    CartDiscountComponent, // NOT IN USE
    CartSubtotalComponent, // NOT IN USE
    CartButtonComponent,
    ToastsContainerComponent,
    ScrollSpyElementDirective
  ],
  providers: [
    BroadcasterService,
    SearchbarService,
    ShoppingCartService,
    ApiService,
    TokenService,
    AuthService,
    MetaTagService,
    FooterService,
    ScrollSpyService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/app.module.ts